<template>
    <div class="tech-talent-manager">
         <Card :padding="10" shadow title="查询条件" class="bt-card">
            <div class="search-con search-con-top">
                <Input v-model.trim="key" clearable @on-enter="searchTechTalentList" @on-clear="searchTechTalentList" placeholder="名称" class="search-input"/>
                <Button type="primary" icon="md-search" @click="searchTechTalentList">搜索</Button>
            </div>
        </Card>
        
        <Card :padding="10" title="科技人才列表" shadow>
            <p slot="extra">
               <Button @click="handleAddTechTalent" type="primary">新增</Button>
            </p>
            <Table :columns="columns" border :data="list" stripe></Table>
            <Page :total="total" :current="page" :page-size="size" @on-change="handlePageChange" @on-page-size-change='handlePageSize' show-total show-elevator show-sizer class-name="bt-page"/>
        </Card>

        <Modal
            v-model="modal"
            :title="editTechTalent.id == 0 ? '新增科技人才' : '编辑科技人才'"
            @on-visible-change="resetForm"
            :width="600">
            <Form ref="editTechTalent" :model="editTechTalent" :label-width="100">
                <FormItem label="名称" prop="name" :rules="{required: true, message: '名称不能为空'}">
                   <Input v-model.trim="editTechTalent.name" placeholder="请输入名称"></Input>
                </FormItem>
                <FormItem label="人才类型" prop="types" :rules="{required: true, message: '人才类型不能为空'}">
                    <Select v-model="editTechTalent.types" placeholder="请选择人才类型">
                        <Option v-for="item in typeList" :key="item" :value="item">{{item}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="图片" prop="pic" :rules="{required: true, message: '图片不能为空'}">
                    <CustomUpload v-model="editTechTalent.pic"></CustomUpload>
                </FormItem>
                <FormItem label="介绍" prop="introduce" :rules="{required: true, message: '介绍不能为空'}">
                    <editor v-model="editTechTalent.introduce"></editor>
                </FormItem>
                <FormItem label="排序码" prop="orders" :rules="{required: true, min: 0,type: 'number',message: '排序码不能为空', trigger: 'change'}">
                   <InputNumber v-model="editTechTalent.orders" placeholder="请输入排序码"></InputNumber>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="modal=false">取消</Button>
                <Button type="primary" size="large" @click="handleTechTalentSubmit">确定</Button>
            </div>
        </Modal>

        <Modal
            v-model="auditBackModal"
            title="审核打回">
            <Form ref="auditBackValue" :model="auditBackValue" :label-width="100">
                <FormItem label="原因" prop="reason" :rules="{required: true, message: '原因不能为空'}">
                   <Input v-model.trim="auditBackValue.reason" maxlength="500" show-word-limit type="textarea" placeholder="请输入原因"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="auditBackModal=false">取消</Button>
                <Button type="primary" size="large" @click="handleAuditBackSubmit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {renderShowImage,formatDate} from '@/utils';
import editor from '@/components/common/Editor';

export default {
    name: 'techTalentManager',
    data(){
        return {
            key: '',
            typeList: ['高校院士','高校专家','科技副总'],
            list: [],
            page: 1,
            size: 20,
            total: 1,
            columns:[{
              key: 'id',
              title: 'ID',
              align: 'center'
           },{
              key: 'name',
              title: '名称',
              tooltip: true
           },{
              key: 'pic',
              title: '图片',
              align: 'center',
              render: renderShowImage
           },{
              key: 'types',
              title: '人才类型',
              align: 'center'
           },{
              key: 'orders',
              title: '排序码',
              align: 'center'
           },{
              key: 'status',
              title: '审核状态',
              align: 'center',
              render: (h,{row,index})=>{
                if(row.status == 0){
                    return h('Tag',{props: {color: 'default'}},'待审核');
                }else if(row.status == 1){
                    return h('Tag',{props: {color: 'primary'}},'审核通过');
                }else {
                    return h('Tag',{props: {color: 'error'},
                        nativeOn: {
                            click: () => {
                                this.lookAuditBackReason(index);
                            }
                        }
                    },'审核失败');
                }
             }
           },{
              key: 'createTime',
              title: '创建时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',formatDate(row.createTime,'yyyy-MM-dd hh:mm:ss'));
              }
           },{
              key: 'modifyTime',
              title: '修改时间',
              align: 'center',
              render: (h,{row})=>{
                  return h('span',formatDate(row.modifyTime,'yyyy-MM-dd hh:mm:ss'));
              }
           },{
              key: 'option',
              title: '操作',
              minWidth: 120,
              render: (h, {row,index}) => {
                 let data = [];
                 if(row.status != 1){
                     data.push(h('Button',{
                        props: {type: 'info',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditTechTalentStatus(index,1);
                            }
                        },
                        directives:[{
                            name: 'permission',
                            value: 'techTalent:audit'
                        }]
                    }, "审核通过"));
                 }
                 if(row.status != 2){
                    data.push(h('Button',{
                        props: {type: 'error',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditTechTalentStatus(index,2);
                            }
                        },
                        directives:[{
                            name: 'permission',
                            value: 'techTalent:audit'
                        }]
                    }, "审核打回"));
                 }
                 data.push(h('Button',{
                        props: {type: 'success',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleEditTechTalent(index);
                            }
                        }
                    }, "编辑"));
                 data.push(h('Button',{
                        props: {type: 'error',size: 'small'},
                        style: {marginRight: '5px'},
                        on: {
                            click: () => {
                                this.handleDeleteTechTalent(index);
                            }
                        }
                    }, "删除"));
                 return h('div', data);
              }
            }],
            modal: false,
            editTechTalent: {
               id: 0,
               name: '',
               types: '',
               thumbnail: '',
               pic: '',
               introduce: '',
               orders: 0,
               status: 0
            },
            auditBackModal: false,
            auditBackValue: {
                id: 0,
                status: 0,
                reason: ''
            }
        }
    },
    created(){
        this.searchTechTalentList();
    },
    methods: {
        searchTechTalentList(){
            this.page = 1;
            this.queryTechTalentList();
        },
        queryTechTalentList(){
            this.$http.post('/api/admin/getTechTalentList',{
                key: this.key,
                pn: this.page,
                ps: this.size
            }).then(data=>{
                this.list = data.list;
                this.size = data.pageSize;
                this.total = data.total;
            });
        },
        handleAddTechTalent(){
            this.editTechTalent.id = 0;
            this.modal = true;
        },
        handleEditTechTalent(index){
            this.editTechTalent = Object.assign({},this.list[index]);
            this.modal = true;
        },
        handleTechTalentSubmit(){
            this.$refs['editTechTalent'].validate((valid) => {
              if(valid) {
                 let techTalent = Object.assign({},this.editTechTalent);
                 this.$http.post('/api/admin/saveTechTalent',techTalent).then(()=>{
                    this.$Message.success("操作成功");
                    this.queryTechTalentList();
                    this.modal = false;
                 });
              }
           });
        },
        openAuditBack(id,status){
           this.auditBackValue = {
               id: id,
               status: status,
               reason: ''
           };
           this.auditBackModal = true;
           this.$refs['auditBackValue'].resetFields();
        },
        handleAuditBackSubmit(){
            this.$refs['auditBackValue'].validate((valid) => {
              if(valid) {
                  this.$http.post('api/admin/updateTechTalentStatus',this.auditBackValue).then(()=>{
                      this.$Message.success("审核打回成功");
                      this.auditBackModal = false;
                      this.queryTechTalentList();
                  });
              }
           });
        },
        handleEditTechTalentStatus(index,status){
            let techTalent = this.list[index];
            if(status == 1){
                this.$Modal.confirm({
                    title: '审核操作',
                    content: '确认审核成功吗？',
                    onOk: () => {
                        this.$http.post('api/admin/updateTechTalentStatus',{id: techTalent.id,status: status}).then(()=>{
                            this.$Message.success("审核成功成功");
                            this.queryTechTalentList();
                        });
                    }
                });
            }else if(status == 2){
                this.openAuditBack(techTalent.id,status);
            }else {
                this.$Message.error("无效状态");
            }
        },
        handleDeleteTechTalent(index){
            this.$Modal.confirm({
              title: '删除操作',
              content: '确认删除该科技人才吗？',
              onOk: () => {
                 let techTalent = this.list[index];
                 this.$http.post('api/admin/deleteTechTalent',{id: techTalent.id}).then(()=>{
                    this.$Message.success("删除成功");
                    this.queryTechTalentList();
                 });
              }
           });
        },
        lookAuditBackReason(index){
            this.$http.post('api/admin/queryAuditLogReason',{itemId: this.list[index].id,itemType: 3},false).then((data)=>{
                this.$Modal.error({
                    title: '打回原因',
                    content: data
                });
            });
        },
        resetForm(show){
           if(!show) {
              this.$refs.editTechTalent.resetFields();
              this.editTechTalent.id = 0;
           }
        },
        handlePageChange(page){
           this.page = page;
           this.queryTechTalentList();
        },
        handlePageSize(size){
           this.size = size;
           this.page = 1;
           this.queryTechTalentList();
        }
    },
    components: {editor}
}
</script>